const AccessibilityLabels = {
  DATEPICKER: 'Select Date',
  CALENDAR: 'Open calendar',
  DROPDOWN: 'Dropdown',
  ICON_BUTTON: 'Please click to take action',
  QUANTITY_STEPPER_MINUS: 'Decrease quantity',
  QUANTITY_STEPPER_PLUS: 'Increase quantity',
  PREVIOUS_PAGE: 'Previous page',
  NEXT_PAGE: 'Next page',
  PLAY: 'Play',
  SHOW_MODAL: 'Expand',
};

export default AccessibilityLabels;
